import React from "react";
import styled from "styled-components";
import {
  CustomerFacingCheckOutModel,
  DonationPricingPageInputsModel,
} from "../models";
import DonationAdvertisingBlock from "./DonationAdvertisingBlock";
import { ImagePlacementTypes } from "../enums";

type IProps = {
  customerFacingCheckOutDetails: CustomerFacingCheckOutModel;
  updateDonationPricingPageData: (data: DonationPricingPageInputsModel) => void;
  onDonationClick: () => void;
  isPreview?: boolean;
};

const BackgroundImageContainer = styled.div<{ imageUrl: string }>`
  background-image: url(${(props) => props.imageUrl});
  background-size: cover;
  background-position: center;
  position: relative;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  height: 100%;
  width: 100%;
  border-radius: 4px;
  background-repeat: no-repeat;
  @media (max-width: 1024px) {
    background-image: none;
  }
`;
const DonationItemWrapper = styled.div`
  height: 100%;
  .donation-image-wrapper {
    /* background: red; */
    display: none;

    /* @media (max-width: 576px) { */  // background image is not visible in tablet view
    @media (max-width: 1024px) {
      display: block;
      /* margin-left: -25px;
      margin-right: -25px;
      margin-top: -25px; */
    }
  }
  .donation-carousel-img {
    height: 100%;
    width: 100%;
    min-width: 254px;
    border-radius: 10px;
    object-fit: fill;
    /* margin-bottom: 20px; */
  }
  .donation-bg-image {
    /* height: calc(100vh - 277px); */
    height: 100%;
    width: 100%;
    .donation-carousel-img {
      // contain is creating issue for full screen
      // fill is creating issue for full screen and the behind image is visible */
      /* object-fit: cover; // sunil asked to change the stretching of image to cover */

      object-fit: cover;
      margin-bottom: 0px !important;
    }
  }
  .donation-img-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    /* height: calc(100vh - 277px); */
    /* background-color: #f8f8f8; */
    padding: 0px;
    border-radius: 10px;
    height: inherit;
  }
  .left-layout {
    .donation-carousel-img {
      border-radius: 10px 0px 0px 10px;
    }
  }
  .right-layout {
    .donation-carousel-img {
      border-radius: 0px 10px 10px 0px;
    }
  }
  .donation-img-bg-wrapper {
    height: calc(100vh - 89px);
    /* height: calc(100vh - 132px); //set the min-height of nav flex to 55ps, so that the fluctuation of height is not there */
    //creating issue when phone and profile nav is missing
    padding: 0px !important;
  }
  .donation-left-right-image {
    /* max-width: 460px; */
    height: calc(100vh - 89px);
    width: 50%;
    .donation-carousel-img {
      display: inline-block;
      //this will make changes in checkout preview and actual rendering
      object-fit: cover;
      &.carousel-original {
        object-fit: contain;
        max-width: 100%;
        max-height: 100%;
        height: auto;
        width: auto;
        border-radius: 10px;
      }
    }
    &.carousel-fit-left {
      display: flex;
      justify-content: center;
      align-items: center;
      padding-left: 50px;
    }
    &.carousel-fit-right {
      display: flex;
      justify-content: center;
      align-items: center;
      padding-right: 50px;
    }
  }
  .bg-img-ss {
    /* margin-bottom: 25px; // adding empty space above image  */
    .donation-carousel-img {
      display: none;
    }
  }
  /* .donation-ad-block{
    overflow-y:unset;
    max-height:unset;
  } */
  /* .help-logo-bar {
      .donation-ad-block {
        max-height: calc(100vh - 164) !important;
      }
    } */

  @media (max-width: 480px) {
    .help-logo-bar {
      .donation-ad-block {
        max-height: calc(100vh - 164) !important;
      }
    }
    .donation-ad-block {
      max-height: calc(100vh - 220px) !important;
      max-height: calc(100vh - 145px) !important; //recent doubtfull changes 
      &.bg-image-ad-block {
        max-height: calc(100vh - 166px) !important;
      }
    }

    .donation-img-bg-wrapper {
      height: calc(100vh - 240px) !important;
      padding: 0px !important;
    }
  }
  @media (max-width: 1024px) {
    .donation-img-bg-wrapper {
      height: calc(100vh - 86px);
      padding: 0px !important;
    }
    /* .donation-left-right-image {
      display: none;
    } */
  }
  @media (max-width: 1024px) {
    .donation-left-right-image {
      width: 100%;
      height: auto;
      display: none; // tab in preview switches to desktop but the image is not visible

      .donation-carousel-img {
        display: none;
        &.carousel-original {
          display: none;
        }
      }
      &.carousel-fit-left,
      &.carousel-fit-right {
        display: none;
      }
    }

    .donation-img-wrapper {
      flex-direction: column;
      gap: 20px;
      /* height: 100%; */
      padding: 20px 0px;
    }
    .donation-carousel-img {
      max-width: unset;
    }
    .bg-img-ss {
      /* display: none; */
      .donation-carousel-img {
        display: none;
        border-radius: 10px !important;
      }
    }
  }

    /* @media (max-width: 576px) { */  // background image is not visible in tablet view
    @media (max-width: 1024px) {
    .donation-bg-image {
      display: none;
      .donation-carousel-img {
        display: none;
      }
    }
  }
`;

const DonationBlock = styled.div<{ placementSlider: number }>`
  // transform: translateX(-${(props) => props.placementSlider}%);
  width: 100%;
  /* height: 100%; */ //creating issue in mobile view for padding
`;

const DonationItem: React.FC<IProps> = ({
  customerFacingCheckOutDetails,
  updateDonationPricingPageData,
  onDonationClick,
  isPreview = false,
}) => {
  const { donationCheckout, donationDetailPage, donationPricingPageData } =
    customerFacingCheckOutDetails;
  const { imagePlacement, media, placementSlider } = donationCheckout;

  return (
    <DonationItemWrapper className="donation-item-wrapper">
      {media.length === 0 || media[0].fullURL === "" ? (
        <DonationAdvertisingBlock
          detailSection={donationDetailPage}
          pricing={donationPricingPageData}
          donationOptions={donationCheckout}
          updateDonationPricingPageData={(
            data: DonationPricingPageInputsModel
          ) => updateDonationPricingPageData(data)}
          onDonationClick={() => onDonationClick()}
          isPreview={isPreview}
          isCustomerFacing={true}
        />
      ) : (
        <>
          {(imagePlacement === ImagePlacementTypes.Left ||
            imagePlacement === ImagePlacementTypes.Right) && (
            <DonationAdvertisingBlock
              detailSection={donationDetailPage}
              pricing={donationPricingPageData}
              donationOptions={donationCheckout}
              updateDonationPricingPageData={(
                data: DonationPricingPageInputsModel
              ) => updateDonationPricingPageData(data)}
              onDonationClick={() => onDonationClick()}
              isPreview={isPreview}
              isCustomerFacing={true}
            />
          )}

          {imagePlacement === ImagePlacementTypes.Background && (
            <BackgroundImageContainer
              imageUrl={media[0].fullURL}
              className="bgImage"
            >
              <DonationBlock placementSlider={placementSlider}>
                <DonationAdvertisingBlock
                  detailSection={donationDetailPage}
                  pricing={donationPricingPageData}
                  donationOptions={donationCheckout}
                  updateDonationPricingPageData={(
                    data: DonationPricingPageInputsModel
                  ) => updateDonationPricingPageData(data)}
                  onDonationClick={() => onDonationClick()}
                  isPreview={isPreview}
                  isCustomerFacing={true}
                />
              </DonationBlock>
            </BackgroundImageContainer>
          )}
        </>
      )}
    </DonationItemWrapper>
  );
};

export default DonationItem;
